let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("aKEZV")).then(() => parcelRequire('kiOkc'));